import React, { useState, useEffect } from "react";

import { Tooltip } from "@mui/material";
import * as IconsSVG from "../../../../assets/iconsSVG";
import productBG from "../../../../assets/images/image-not-found.jpg";
import * as Styles from "./styles";

interface Props {
  idEmpreendimento: string;
  nomeEmpreendimento: string;
  nomeBandeira: string;
  urlImagemPrincipal: string;
  statusEmpreendimento: string;
  quantidadeQuartos: string;
  metragemEmpreendimento: string;
  vagasGaragem: string;
  quantidadeDisponivel: number;
}

const ProductCard: React.FC<Props> = ({
  idEmpreendimento,
  nomeEmpreendimento,
  nomeBandeira,
  urlImagemPrincipal,
  statusEmpreendimento,
  quantidadeQuartos,
  metragemEmpreendimento,
  vagasGaragem,
  quantidadeDisponivel,
}) => {
  const [color, setColor] = useState<string>("#8C6320");

  useEffect(() => {
    switch (nomeBandeira) {
      case "CYRELA":
        setColor("#8C6320");
        break;
      case "LIVING":
        setColor("#242C57");
        break;
      case "VIVAZ":
        setColor("#960064");
        break;
      case "Outros":
        setColor("#000000");
        break;
      case null:
        setColor("#000000");
        break;
      default:
        break;
    }
  }, []);
  const getTitle = () => {
    if (nomeBandeira === "CYRELA") {
      return "Cyrela";
    }
    if (nomeBandeira === "LIVING") {
      return "Living";
    }
    if (nomeBandeira === "VIVAZ") {
      return "VIVAZ";
    }
    if (nomeBandeira === "Outros") {
      return "Outros";
    }
    if (nomeBandeira === null) {
      return "Outros";
    }
    return "Outros";
  };
  return (
    <Styles.ProductCard href={`/produtos/${idEmpreendimento}`}>
      <Styles.BoxImg>
        <img src={urlImagemPrincipal || productBG} alt="Product img" />
        {nomeBandeira === "Outros" || nomeBandeira === null ? (
          <></>
        ) : (
          <>
            <Tooltip title={getTitle()} placement="top" followCursor arrow>
              <Styles.Flag>
                {nomeBandeira === "CYRELA" && <IconsSVG.CyrelaIcon />}
                {nomeBandeira === "LIVING" && <IconsSVG.LivingIcon />}
                {nomeBandeira === "VIVAZ" && <IconsSVG.VivazIcon />}
              </Styles.Flag>
            </Tooltip>
            <Styles.Status>{statusEmpreendimento || "--"}</Styles.Status>
          </>
        )}
      </Styles.BoxImg>
      <Styles.BoxContent>
        <Styles.PrdTitle>{nomeEmpreendimento || "--"}</Styles.PrdTitle>
        <Styles.Row>
          <Tooltip title="Dormitórios" placement="top" followCursor arrow>
            <Styles.Item>
              <IconsSVG.ProductRoomIcon
                size="16"
                viewBox="0 0 21 21"
                color={color}
              />
              <Styles.TextItem>{quantidadeQuartos || "--"}</Styles.TextItem>
            </Styles.Item>
          </Tooltip>
          <Tooltip title="Metragem" placement="top" followCursor arrow>
            <Styles.Item>
              <IconsSVG.ProductSizeIcon color={color} />
              <Styles.TextItem>
                {metragemEmpreendimento || "--"}
              </Styles.TextItem>
            </Styles.Item>
          </Tooltip>
          <Tooltip title="Vagas Garagem" placement="top" followCursor arrow>
            <Styles.Item>
              <IconsSVG.ProductParkIcon color={color} />
              <Styles.TextItem>{vagasGaragem || "--"}</Styles.TextItem>
            </Styles.Item>
          </Tooltip>
          {/* <Tooltip
            title="Unidades Disponíveis"
            placement="top"
            followCursor
            arrow
          >
            <Styles.Item>
              <IconsSVG.ProductAvailableIcon color={color} />
              <Styles.TextItem>{quantidadeDisponivel || "--"}</Styles.TextItem>
            </Styles.Item>
          </Tooltip> */}
        </Styles.Row>
      </Styles.BoxContent>
    </Styles.ProductCard>
  );
};

export default ProductCard;
